export var CARD_TYPE;
(function (CARD_TYPE) {
  CARD_TYPE["other"] = "other";
  CARD_TYPE["elk"] = "elk";
  CARD_TYPE["product"] = "product";
  CARD_TYPE["service"] = "service";
  CARD_TYPE["tariff"] = "tariff";
  CARD_TYPE["history"] = "history";
})(CARD_TYPE || (CARD_TYPE = {}));
export var ECard;
(function (ECard) {
  ECard["other"] = "\u0434\u0440\u0443\u0433\u043E\u0435";
  ECard["elk"] = "\u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442";
  ECard["product"] = "\u0442\u043E\u0432\u0430\u0440\u044B";
  ECard["service"] = "\u0443\u0441\u043B\u0443\u0433\u0438";
  ECard["tariff"] = "\u0442\u0430\u0440\u0438\u0444\u044B";
})(ECard || (ECard = {}));
export var STEP;
(function (STEP) {
  STEP["recently"] = "recently";
  STEP["result"] = "result";
})(STEP || (STEP = {}));
export var ATTRIBUTES_NAME;
(function (ATTRIBUTES_NAME) {
  ATTRIBUTES_NAME["badges"] = "\u0431\u044D\u0439\u0434\u0436\u0438";
  ATTRIBUTES_NAME["elk"] = "\u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442";
  ATTRIBUTES_NAME["preOrder"] = "\u043F\u0440\u0435\u0434\u0437\u0430\u043A\u0430\u0437";
  ATTRIBUTES_NAME["product"] = "\u0442\u043E\u0432\u0430\u0440";
  ATTRIBUTES_NAME["service"] = "\u0443\u0441\u043B\u0443\u0433\u0430 \u0438\u043B\u0438 \u0430\u043A\u0446\u0438\u044F";
  ATTRIBUTES_NAME["tariff"] = "\u0442\u0430\u0440\u0438\u0444";
})(ATTRIBUTES_NAME || (ATTRIBUTES_NAME = {}));
export var TYPE_ANALYTICS_RESULT = {
  other: 'others',
  elk: 'elk',
  product: 'goods',
  service: 'tariffs',
  tariff: 'tariffs'
};
export var CATEGORIES = {
  other: 'Другое',
  elk: '1540',
  service: '1265',
  tariff: '101',
  product: '10',
  history: 'История'
};
export var UNIT = 'мес';
export var PRIORITY_LIST = ['tariffs', 'products', 'services', 'elk', 'others'];
export var CATEGORY_LIST = ['elk', 'tariffs', 'products', 'services', 'others'];
export var ERROR_CONTENT_TEXT = 'находит тот, кто ищет — \nи проверяет на опечатки';
export var EMPTY_CONTENT_TEXT = 'находит тот, кто ищет — \nи проверяет на опечатки';
export var INPUT_PLACEHOLDER_TEXT = 'найти в билайне';
export var TITLE_TEXT = 'поиск';
export var RESULT_TEXT = 'все результаты';
export var TITLES_BLOCK = {
  history: 'история поиска',
  recently: 'советуем посмотреть',
  product: 'товары',
  tariff: 'тарифы',
  service: 'услуги',
  other: 'другое',
  elk: 'личный кабинет'
};